module.exports = __webpack_public_path__ + "static/media/ic-concerts.6060482d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ic-concerts.svg
// module id = 436
// module chunks = 0